import { PropsWithChildren } from "react";
import { Message } from "primereact/message";

import Label from "./Label";
import { PropsWithClassName } from "../../types/PropsWithClassName";

interface FormGroupProps extends PropsWithChildren, PropsWithClassName {
  label?: string;
  errorMessage?: string;
  noMargin?: boolean;
  size?: "small" | "large";
  inline?: boolean;
  checkbox?: boolean;
}

export default function FormGroup({ className, label, errorMessage, noMargin, size, inline, checkbox, children }: FormGroupProps) {
  const isSmall = size === "small";

  const getMarginClassName = () => (noMargin ? "" : isSmall ? "mb-1" : "mb-4");

  const getGapClassName = () => (isSmall ? "gap-1" : "gap-2");

  return checkbox ? (
    <Label className={`${className} ${getMarginClassName()} ${getGapClassName()} flex align-items-center cursor-pointer`}>
      {children}
      {label}
    </Label>
  ) : (
    <div
      className={`${className} ${getMarginClassName()} ${getGapClassName()} ${inline ? "flex-row align-items-center" : "flex-column"} flex`}
    >
      {label && <Label>{label}</Label>}
      {children}
      {errorMessage && <Message severity="error" text={errorMessage}></Message>}
    </div>
  );
}
